import { initialSettings } from './reducers/common/settings'

function loadState() {
  try {
    const serializedState = sessionStorage.getItem( 'smm' );
    if( serializedState === null ) {
      return undefined
    }
    const state = JSON.parse( serializedState );
    return { ...state, settings: { ...initialSettings, ...state.settings } }
  } catch( err ) {
    return undefined
  }
}

function saveState( state ) {
  try {
    const stateToPersist = {
      user: state.user,
      settings: {
        isApiError: state.settings.isApiError,
        apiErrorMessage: state.settings.apiErrorMessage,
        apiStatus: state.settings.apiStatus,
        networkSettings: state.settings.networkSettings,
        extraMenu: state.settings.extraMenu,
        externalAuthenticationRequired: state.settings.externalAuthenticationRequired,
        imsDomainActive: state.settings.imsDomainActive,
        chatActive: state.settings.chatActive,
        phoneActive: state.settings.phoneActive,
        clientFolderIframe: state.settings.clientFolderIframe,
        reportActive: state.settings.reportActive,
        dateFormat: state.settings.dateFormat ,
        dateTimeFormat: state.settings.dateTimeFormat ,
        closeOnReply: state.settings.closeOnReply,
        externalCodes: state.settings.externalCodes,
        documentHelpUrl: state.settings.documentHelpUrl,
        externalApiUrl: state.settings.externalApiUrl,
        externalCustomer: state.settings.externalCustomer,
        googleMapKey: state.settings.googleMapKey,
        uploadFile: state.settings.uploadFile,
        urlWeb : state.settings.urlWeb,
      },
      websocket: {
        status: state.websocket.status,
        data: state.websocket.data
      }
    };
    const serializedState = JSON.stringify( stateToPersist );
    sessionStorage.setItem( 'smm', serializedState );
  } catch( err ) {
  }
}

export { loadState, saveState };



// WEBPACK FOOTER //
// ./stores/localStorage.js